import React, { useEffect, useState } from "react";
import { API_URL, authFetch } from "../../utils/auth";

export default function WelcomeMessageCard() {
  const [enabled, setEnabled] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    authFetch(`${API_URL}/partner/welcome-message-settings/`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data) {
          setEnabled(Boolean(data.auto_send_client_welcome_message));
          setMessage(data.client_welcome_message || "");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  async function saveSettings(e) {
    e.preventDefault();
    setSaving(true);
    setStatus("");
    try {
      const response = await authFetch(`${API_URL}/partner/welcome-message-settings/`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          auto_send_client_welcome_message: enabled,
          client_welcome_message: message,
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || "Unable to save welcome message settings.");
      setEnabled(Boolean(data.auto_send_client_welcome_message));
      setMessage(data.client_welcome_message || "");
      setStatus("Saved.");
    } catch (err) {
      setStatus(err.message || "Unable to save settings.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <form className="settings-card welcome-message-card" onSubmit={saveSettings}>
      <h3>Client Welcome Message</h3>
      <p className="hint">When enabled, this message will be sent automatically after a client you referred receives their portal account.</p>

      {loading ? (
        <p className="hint">Loading welcome message settings...</p>
      ) : (
        <>
          <label className="toggle welcome-toggle">
            <span>Automatically message new referred clients</span>
            <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
          </label>

          <label className="welcome-field">
            <span>Welcome message</span>
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} maxLength={5000} placeholder="Welcome to the portal. I am here if you have questions as your project moves forward." />
          </label>

          <div className="welcome-preview">
            <strong>Preview</strong>
            <p>{message.trim() || "Your welcome message preview will appear here."}</p>
          </div>

          <div className="settings-actions-row">
            <small>{message.length}/5000</small>
            <button className="btn" type="submit" disabled={saving}>{saving ? "Saving..." : "Save"}</button>
          </div>
          {status && <p className="hint">{status}</p>}
        </>
      )}
    </form>
  );
}
